/* eslint-disable indent */
import { useContext, useEffect } from 'react';

import { sendAnalyticEvent } from '@src/components/web-analytic/utils';
import { analyticEvents } from '@src/constants';
import { useCustomerEventRegister } from '@src/hooks';
import { Store } from '@src/store';

export const useAnalyticsMite = () => {
  const {
    state: {
      stateWizard: { wantNextStep, currentStep },
      stateMite: { startDate, choosedPolicy },
    },
  } = useContext(Store);

  const { refetch: refetchCustomerEventRegister } = useCustomerEventRegister({
    eventCode: analyticEvents.miteToStepData,
    contextData: {
      startDate: startDate.toISOString(),
      program: choosedPolicy,
    },
  });

  useEffect(() => {
    if (wantNextStep) {
      switch (currentStep) {
        case 1:
          sendAnalyticEvent(analyticEvents.miteToStepData);
          refetchCustomerEventRegister();
          break;
        default:
          break;
      }
    }
  }, [wantNextStep]);
};
